module.exports = __webpack_public_path__ + "static/media/Blocks-2.6s-200px (2).f1baa66f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/Blocks-2.6s-200px (2).svg
// module id = ./src/CSS/assets-minified/Blocks-2.6s-200px (2).svg
// module chunks = 0